import React from "react";

const ROLE_LABELS = {
  admin: "Admin",
  manager: "Warehouse Manager", 
  inventory: "Warehouse Staff",
  billing_user: "Billing User",
  employee: "Inventory Lead",
  client: "Customer Admin",
  viewer: "Inventory Viewer",
  shopper: "Inventory Shopper",
  guest: "Guest",
};

const RoleField = ({ value }) => {
  const displayLabel = ROLE_LABELS[value] || value;

  return <span>{displayLabel}</span>;
};

export default RoleField; 